import ProfessorProjectPage from '@/pages/ProfessorProjectPage/ProfessorProjectPage'
import { PAGE_LINKS, PROFESSOR_ROOT } from '../pageConst'
import ProfessorLoginPage from '@/pages/ProfessorLoginPage/ProfessorLoginPage'
import ProfessorDashboardLayout from '@/components/ProfessorDashboardLayout/ProfessorDashboardLayout'
import ProfessorProjectDetailPage from '@/pages/ProfessorProjectDetailPage/ProfessorProjectDetailPage'
import { Navigate } from 'react-router-dom'
import AuthRenderer from '@/components/AuthRenderer/AuthRenderer'

const routes = [
  {
    path: PAGE_LINKS.professorProject,
    element: <ProfessorProjectPage />,
  },
  {
    path: PAGE_LINKS.professorProjectDetail,
    element: <ProfessorProjectDetailPage />,
  },
  {
    /** NOT FOUND */
    path: '*',
    element: <Navigate to={PAGE_LINKS.professorProject} replace />,
  },
]

export const professorRoutes = [
  {
    path: PAGE_LINKS.professorLogin,
    element: <ProfessorLoginPage />,
  },
  {
    path: PROFESSOR_ROOT,
    element: <ProfessorDashboardLayout />,
    children: routes.map((route) => {
      return route.path === '' || route.path === '*'
        ? route
        : {
            ...route,
            element: <AuthRenderer mode='professor'>{route.element}</AuthRenderer>,
          }
    }),
  },
]
